import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { FAQScaffold } from "components/features/CompressorCommon/FAQScaffold";

interface IFaq {
    question: string;
    answer: string;
}

const faqAsList: IFaq[] = [
    {
        question: "jpg-compressor-faq-why-use-question",
        answer: "jpg-compressor-faq-why-use-ans",
    },
    {
        question: "jpg-compressor-faq-best-compressor-question",
        answer: "jpg-compressor-faq-best-compressor-ans",
    },
    {
        question: "jpg-compressor-faq-compress-multiple-question",
        answer: "jpg-compressor-faq-compress-multiple-ans",
    },
    {
        question: "jpg-compressor-faq-difference-question-question",
        answer: "jpg-compressor-faq-difference-ans",
    },
    {
        question: "jpg-compressor-faq-compare-images-question",
        answer: "jpg-compressor-faq-compare-images-ans",
    },
    {
        question: "jpg-compressor-faq-compress-time-question",
        answer: "jpg-compressor-faq-compress-time-ans",
    },
    {
        question: "jpg-compressor-faq-support-question",
        answer: "jpg-compressor-faq-support-ans",
    },
];
const JpegCompressorFaq = () => {
    return (
        <FAQScaffold
            faqAsList={faqAsList}
            sectionTitle={<Translate keyName="jpg-compressor-faq-title" />}
            sectionSubTitle={<Translate keyName="jpg-compressor-faq-sub-title" />}
        />
    );
};

export default JpegCompressorFaq;
